import type { FC } from "react";
import { useCalculatorAccessQuery } from "web_myplann/Api/Calculators/useCalculatorAccessQuery";
import { CalculatorListSkeleton } from "web_myplann/Calculators/Components/CalculatorListSkeleton";
import { CalculatorNote } from "web_myplann/Calculators/Components/CalculatorNote";
import { CalculatorSectionList } from "web_myplann/Calculators/Components/CalculatorSectionList";
import { useOpenCalculator } from "web_myplann/Calculators/Hooks/useOpenCalculator";
import type { CalculatorType } from "web_myplann/Calculators/Types/CalculatorType";
import {
	CALCULATOR_SECTIONS,
	CALCULATOR_TYPES,
} from "web_myplann/Calculators/Utils/calculatorCatalog";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	onUnavailableSelect: (type: CalculatorType) => void;
};

export const CalculatorListContent: FC<Props> = ({ onUnavailableSelect }) => {
	const { t } = useResource();
	const { openCalculator } = useOpenCalculator();
	const {
		data: access,
		isPending,
		isPaused,
		isError,
	} = useCalculatorAccessQuery();

	if (isError || (isPaused && !access)) {
		return <CalculatorNote text={t(Resources.Calculators.ListError)} />;
	}

	if (isPending || !access) {
		return <CalculatorListSkeleton />;
	}

	if (!CALCULATOR_TYPES.some((type) => access[type].isVisible)) {
		return <CalculatorNote text={t(Resources.Calculators.ListEmpty)} />;
	}

	return (
		<CalculatorSectionList
			sections={CALCULATOR_SECTIONS}
			access={access}
			onSelect={openCalculator}
			onUnavailableSelect={onUnavailableSelect}
		/>
	);
};
